<template>
  <v-btn
    v-bind="$attrs"
    icon
    :color="color"
    class="white--text"
    v-on="inputListeners"
  >
    <v-icon
      large
    >
      <slot />
    </v-icon>
  </v-btn>
</template>
<script>
  export default {
    name: 'IconButton',
    props: {
      color: {
        type: String,
        required: false,
        default: 'primaryTeal',
      },
    },
    computed: {
      inputListeners: function () {
        var vm = this
        // `Object.assign` merges objects together to form a new object
        return Object.assign(
          {},
          // We add all the listeners from the parent
          this.$listeners,
          // Then we can add custom listeners or override the
          // behavior of some listeners.
          {
            // This ensures that the component works with v-model
            click: function (event) {
              vm.$emit('click', event)
            },
          },
        )
      },
    },
  }
</script>
<style scoped>
.v-btn::before {
  background-color: transparent
}
</style>
